export const CERBERUS_STATS_CHART_LIMIT = 8;

export const GEO_TYPE = {
  MSA: 'MSA',
  ZIP: 'ZIP',
  CITY: 'CITY',
} as const;

export const CHART_TAB_IDS = {
  MarketActivity: 'market-activity',
  MacroInsights: 'macro-insights',
} as const;

export const CERBERUS_STATS_TYPE = {
  Msa: 'Msa',
  Zip: 'Zip',
  City: 'City',
  ListingStats: 'ListingStats',
  RentalListingStats: 'RentalListingStats',
} as const;
